import { MenuItem as MenuItemComponent } from "@/app/(site)/_components/Molecules/MenuItem"
import { MenuItemTypes } from "@/app/(site)/_mockdata/menuItems"
import { DropdownVisibilityState } from "../Header"

interface Props {
    items: MenuItemTypes[] | undefined
    level: number
    replaceHistory?: boolean
    setDropdownVisibility: (dropdownVisibility: DropdownVisibilityState) => void
}

const getLevelString = (level: number): "top" | "second" | "third" | "fourth" => {
    switch (level) {
        case 1:
            return "top"
        case 2:
            return "second"
        case 3:
            return "third"
        case 4:
            return "fourth"
        default:
            return "top"
    }
}

const Menu = ({ items, level, replaceHistory, setDropdownVisibility }: Props) => (
    <ul>
        {Array.isArray(items) &&
            items.length > 0 &&
            items.map((item, index) => {
                const hasChildren = item.menuItems && item.menuItems.length > 0
                return (
                    <li
                        role="menuitem"
                        key={index}
                        className={`${level > 1 && level < 3 ? "pl-12" : ""} ${
                            level === 2 ? "border-l-2 border-black" : ""
                        }`}
                        onClick={() => {
                            if (!item.isNavigationContainer) {
                                setDropdownVisibility({})
                            }
                        }}
                    >
                        <MenuItemComponent
                            level={getLevelString(level)}
                            item={item}
                            to={item.uri}
                            label={item.title}
                            replaceHistory={replaceHistory}
                            className="w-full py-2"
                        />

                        {/* Recursively render child menu items */}
                        {hasChildren && (
                            <Menu
                                setDropdownVisibility={setDropdownVisibility}
                                items={item.menuItems}
                                level={level + 1}
                                replaceHistory={replaceHistory}
                            />
                        )}
                    </li>
                )
            })}
    </ul>
)

export default Menu
